import React from "react";
import { Link } from "react-router-dom";

function OperationTheatre() {
  return (
    <>
      <style>{`
        .product-container {
          width: 100%;
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-wrap: wrap;
          background-color: #f0f0f0;
          padding: 20px;
          gap: 20px;
          box-sizing: border-box;
        }

        .product {
          width: 22%;
          height: 330px;
          border: 3px solid black;
          border-radius: 13px;
          background-color: white;
          overflow: hidden;
          box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          animation: slideUpFade 0.6s ease-in-out;
        }

        .product:hover {
          transform: scale(1.03);
          box-shadow: 0 10px 16px rgba(0, 0, 0, 0.2);
        }

        .product img {
          width: 100%;
          height: 200px;
          object-fit: contain;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          background-color: #fff;
        }

        .product p {
          padding: 10px;
          text-align: center;
          font-size: 1.1rem;
          margin: 0;
          height: 80px;
        }

        .product button {
          width: 100%;
          padding: 10.23px;
          background-color: #007bff;
          color: white;
          border: none;
          border-radius: 0 0 10px 10px;
          cursor: pointer;
          font-size: 1rem;
        }

        @media (max-width: 768px) {
          .product {
            width: 45%;
          }
        }

        @media (max-width: 480px) {
          .product {
            width: 100%;
          }
        }

        @keyframes slideUpFade {
          0% {
            transform: translateY(30px);
            opacity: 0;
          }
          100% {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>

      <div className="product-container">
        <div className="product">
          <img src="ot19.png" alt="product1" />
          <p>Fixed Surgical Pandant</p>
           <Link to="/fixed-surgical-pandant">
            <button>View Details</button>
          </Link>
            </div>
            <div className="product">
          <img src="ot25.jpeg" alt="product1" />
          <p>Single Arm Surgical Pandant</p>
           <Link to="/single-arm-surgical-pandant">
            <button>View Details</button>
          </Link>
            </div>
             <div className="product">
          <img src="ot26.jpeg" alt="product1" />
          <p>Double Arm Surgical Pandant</p>
           <Link to="/double-arm-surgical-pandant">
            <button>View Details</button>
          </Link>
            </div>
             <div className="product">
          <img src="ot24.png" alt="product1" />
          <p>Fixed Anesthetic Pandant</p>
           <Link to="/fixed-anesthetic-pandant">
            <button>View Details</button>
          </Link>
            </div>
            <div className="product">
          <img src="ot8.jpeg" alt="product1" />
          <p>Single Arm Anesthetic Pandant</p>
           <Link to="/single-arm-anesthetic-pandant">
            <button>View Details</button>
          </Link>
            </div>
            
        
        
        <div className="product">
          <img src="ot1.jpeg" alt="product1" />
          <p>Double Arm Anesthetic Pandant</p>
           <Link to="/double-arm-anesthetic-pandant">
            <button>View Details</button>
          </Link>
        </div>
        <div className="product">
          <img src="ot2.jpeg" alt="product1" />
          <p>Modular Fixed Pandant</p>
           <Link to="/modular-fixed-pandant">
            <button>View Details</button>
          </Link>

          
          
        </div>
        <div className="product">
          <img src="ot3.jpeg" alt="product1" />
          <p>Modular Single Arm Pandant</p>
           <Link to="/modular-single-arm-pandant">
            <button>View Details</button>
          </Link>
            </div>
             <div className="product">
          <img src="ot4.jpeg" alt="product1" />
          <p>Modular Double Arm Pandant</p>
           <Link to="/modular-double-arm-pandant">
            <button>View Details</button>
          </Link>
            </div>
             <div className="product">
          <img src="ot5.jpeg" alt="product1" />
          <p>Modular Electric Single Arm Pandant</p>
           <Link to="/modular-electric-single-arm-pandant">
            <button>View Details</button>
          </Link>
            </div>
             <div className="product">
          <img src="ot6.jpeg" alt="product1" />
          <p>Modular Electric Double Arm Pandant</p>
           <Link to="/modular-electric-double-arm-pandant">
            <button>View Details</button>
          </Link>
            </div>
               <div className="product">
          <img src="ot20.png" alt="product1" />
          <p>Wall Card</p>
           <Link to="/wall-card">
            <button>View Details</button>
          </Link>
            </div>
        <div className="product">
          <img src="ot21.png" alt="product1" />
          <p>Corner Card</p>
           <Link to="/corner-card">
            <button>View Details</button>
          </Link>
            </div>
             <div className="product">
          <img src="ot7.jpeg" alt="product1" />
          <p>SS Scrub Sink</p>
           <Link to="/ss-scrub-sink">
            <button>View Details</button>
          </Link>
            </div>
             <div className="product">
          <img src="ot10.jpeg" alt="product1" />
          <p>Laminar Air Flow</p>
           <Link to="/laminar-air-flow">
            <button>View Details</button>
          </Link>
            </div>
             
             <div className="product">
          <img src="ot9.jpeg" alt="product1" />
          <p>Modular Hatch Box</p>
           <Link to="/modular-hatch-box">
            <button>View Details</button>
          </Link>
            </div>
            
             <div className="product">
          <img src="ot11.jpeg" alt="product1" />
          <p>Harmetic Seal Swinger Door</p>
           <Link to="/hermetic-seal-swinger-door">
            <button>View Details</button>
          </Link>
            </div>
             <div className="product">
          <img src="ot12.jpeg" alt="product1" />
          <p>Harmetically Sealed Sliding Door</p>
           <Link to="/hermetically-sealed-sliding-door">
            <button>View Details</button>
          </Link>
            </div>
              <div className="product">
          <img src="ot22.png" alt="product1" />
          <p>Control Panel</p>
           <Link to="/control-panel">
            <button>View Details</button>
          </Link>
            </div>
            <div className="product">
          <img src="ot23.png" alt="product1" />
          <p>Surgeon Control Panel</p>
           <Link to="/surgeon-control-panel">
            <button>View Details</button>
          </Link>
            </div>
            <div className="product">
          <img src="ot17.png" alt="product1" />
          <p>X-Ray Board</p>
           <Link to="/x-ray-board">
            <button>View Details</button>
          </Link>
            </div>
              <div className="product">
          <img src="ot16.png" alt="product1" />
          <p>Writing Board</p>
           <Link to="/writing-board">
            <button>View Details</button>
          </Link>
            </div>
             <div className="product">
          <img src="ot15.png" alt="product1" />
          <p>Peripheral Light</p>
           <Link to="/peripheral-light">
            <button>View Details</button>
          </Link>
            </div>
            <div className="product">
          <img src="ot13.png" alt="product1" />
          <p>Pressure Relief Damper</p>
           <Link to="/pressure-relief-damper">
            <button>View Details</button>
          </Link>
            </div>
                <div className="product">
          <img src="ot18.jpeg" alt="product1" />
          <p>Curtain Track & System</p>
           <Link to="/curtain-track-system">
            <button>View Details</button>
          </Link>
            </div>
            <div className="product">
          <img src="ot14.png" alt="product1" />
          <p>Nurse Call System</p>
           <Link to="/nurse-call-system">
            <button>View Details</button>
          </Link>
            </div>
           
          
            
        
            
         
          
           
            
        
       
       
    
       
        </div>
        
        
      
    </>
  );
}

export default OperationTheatre;
